import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Toaster } from 'react-hot-toast';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// import reportWebVitals from './reportWebVitals';
import { SocketProvider } from 'Context/SocketContext';
import { store } from './store';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <LocalizationProvider dateAdapter={AdapterDayjs}>
    <Provider store={store}>
      <SocketProvider>
        <ToastContainer />
        <App />
      </SocketProvider>
    </Provider>
    <Toaster />
  </LocalizationProvider>
);

serviceWorkerRegistration.register();
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
